var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "@irati/store";
import { MenuLinkLeft } from "../SideBar";
import StyledCol from "./styled/StyledCol";
import mainTheme from "../../global/theme";
var Div = function (props) { return React.createElement("div", __assign({}, props)); };
var AccountWrapper = /** @class */ (function (_super) {
    __extends(AccountWrapper, _super);
    function AccountWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountWrapper.prototype.render = function () {
        var _a = this.props, useGrid = _a.useGrid, isMobile = _a.isMobile, match = _a.match, location = _a.location, indexRedirect = _a.indexRedirect, children = _a.children, MobileMenu = _a.MobileMenu, mobileBack = _a.mobileBack, mobileBackLink = _a.mobileBackLink, Menu = _a.Menu, usesNewSideNav = _a.usesNewSideNav;
        if (match.url === location.pathname) {
            if (!isMobile) {
                var to = __assign(__assign({}, location), { pathname: "" + match.url + indexRedirect });
                return React.createElement(Redirect, { to: to });
            }
            return React.createElement(MobileMenu, null);
        }
        var Wrapper = useGrid ? Grid : Div;
        return (React.createElement(Wrapper, { style: { marginTop: isMobile ? mainTheme.spacing.one : mainTheme.spacing.six } },
            React.createElement(Row, null,
                React.createElement(Col, { xsHidden: true, sm: usesNewSideNav ? 4 : 3 },
                    React.createElement(Menu, null)),
                React.createElement(StyledCol, { xs: 12, smHidden: true, mdHidden: true, lgHidden: true },
                    React.createElement(MenuLinkLeft, { to: mobileBackLink }, mobileBack)),
                React.createElement(StyledCol, { xs: 12, sm: usesNewSideNav ? 8 : 9 }, children))));
    };
    AccountWrapper.defaultProps = {
        mobileBack: "Back home",
        mobileBackLink: "/account",
        useGrid: true,
        usesNewSideNav: false
    };
    return AccountWrapper;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: mq.lessThan.medium
    };
};
export default withRouter(connect(mapStateToProps)(AccountWrapper));
